import { useEffect } from "react";

const STAT_BY_METRIC = {
  new_leads: "status:new",
  lead_discovery: "status:discovery",
  lead_proposal: "status:proposal",
};

// Route-driven tab changes must preserve the funnel's server-side filter.
// Keep this in one effect so a tab reset cannot overwrite the selected stage.
export default function useLeadRouteStat({ listTab, overviewMetric, pipelineStatId, setActiveStatId }) {
  useEffect(() => {
    setActiveStatId(listTab === "sales-pipeline"
      ? pipelineStatId
      : listTab === "leads" ? STAT_BY_METRIC[overviewMetric] || "total" : "total");
  }, [listTab, overviewMetric, pipelineStatId, setActiveStatId]);
}
